import { defineField, defineType } from 'sanity'

export default defineType({
  title: '3 Boxes',
  name: 'threeBoxes',
  type: 'object',
  fields: [
    defineField({
      title: '3 Feature Boxes',
      name: 'featureBoxes',
      type: 'array',
      of: [{ type: 'featureBox' }],
      validation: (Rule) => Rule.length(3),
    }),
    defineField({
      title: 'Button',
      type: 'link',
      name: 'button',
    }),
  ],
})